import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, Table, Modal as AntModal, Space } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Footer from "../../../components/Footer";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import { API_URL, TOKEN } from "../../../variables/constants";
import AddBanque from "./AddBanque";
import ActionDropdown from "../../production/components/ActionDropdown";

const Banques = () => {
  const [banques, setBanques] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedBanque, setSelectedBanque] = useState(null);

  // Pas besoin de tableKey avec cette approche, car on re-fetch tout
  // const [tableKey, setTableKey] = useState(0);

  // Charge les banques au premier rendu du composant
  useEffect(() => {
    fetchBanques();
  }, []); // Le tableau vide assure que cela ne s'exécute qu'une fois au montage

  // Fonction pour récupérer les banques depuis l'API
  const fetchBanques = () => {
    axios
      .get(`${API_URL}/api/parametre/type/BANQUE`, {
        headers: { Authorization: `Bearer ${TOKEN}` },
      })
      .then((res) => {
        // Trie les banques par ID décroissant pour afficher les plus récentes en premier
        const sorted = res.data.sort((a, b) => b.parametreId - a.parametreId);
        setBanques(sorted);
        // Pas besoin d'incrémenter tableKey ici, car le re-fetch met à jour les données
      })
      .catch((err) => console.error("Erreur récupération banques:", err));
  };

  // Ouvre la modale d'ajout/modification
  const handleShow = (edit = false, banque = null) => {
    setShowModal(true);
    setEditMode(edit);
    setSelectedBanque(banque);
  };

  // Ferme la modale
  const handleClose = () => {
    setShowModal(false);
    setEditMode(false);
    setSelectedBanque(null);
  };

  // Cette fonction est appelée par AddBanque après un ajout/modification réussi
  const handleActionComplete = () => {
    fetchBanques(); // Re-charge toutes les banques pour synchroniser l'affichage
  };

  // Gère la suppression d'une banque
  const handleDeleteBanque = (parametreId) => {
    AntModal.confirm({
      title: "Êtes-vous sûr de vouloir supprimer cette banque ?",
      content: "Cette action est irréversible",
      okText: "Oui",
      okType: "danger",
      cancelText: "Annuler",
      onOk: () => {
        axios
          .delete(`${API_URL}/api/parametre/${parametreId}`, {
            headers: { Authorization: `Bearer ${TOKEN}` },
          })
          .then(() => {
            // Après suppression, on peut soit re-fetch, soit filtrer localement.
            // Pour la cohérence, un re-fetch est souvent plus sûr.
            // Ou, si l'API est fiable, on peut filtrer localement:
            setBanques((prev) =>
              prev.filter((b) => b.parametreId !== parametreId)
            );
            toast.success("Banque supprimée avec succès.");
          })
          .catch((err) => {
            console.error("Erreur suppression banque:", err);
            toast.error("Erreur lors de la suppression de la banque");
          });
      },
    });
  };

  // Définition des colonnes pour la table Ant Design
  const columns = [
    {
      title: "Nom",
      dataIndex: "libelleParametre",
      key: "libelleParametre",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <ActionDropdown
          actions={[
            {
              key: "edit",
              label: "Modifier",
              icon: <i className="bx bx-edit-alt" />,
              onClick: () => handleShow(true, record),
            },
            {
              key: "delete",
              label: "Supprimer",
              icon: <i className="bx bx-trash" />,
              danger: true,
              onClick: () => handleDeleteBanque(record.parametreId),
            },
          ]}
        />
      ),
    },
  ];

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu="AUTRES_PARAMETRES" />
        <div className="layout-page">
          <NavBar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                style={{ marginBottom: 16 }}
                onClick={() => handleShow()}
              >
                Ajouter une nouvelle banque
              </Button>
              <div className="card">
                <h5 className="card-header">Liste des banques</h5>
                <Table
                  // Plus besoin de key={tableKey} ici, dataSource est la source de vérité
                  columns={columns}
                  dataSource={banques}
                  rowKey="parametreId"
                  pagination={{ pageSize: 10, showSizeChanger: true }}
                />
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

      <AddBanque
        show={showModal}
        handleClose={handleClose}
        editMode={editMode}
        selectedBanque={selectedBanque}
        banques={banques} // Toujours utile pour la validation des doublons
        onActionComplete={handleActionComplete} // Passe la fonction de re-fetch
      />
    </div>
  );
};

export default Banques;
